import { ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackOutbound } from "../lib/analytics";
import { SpotifyIcon, YouTubeIcon } from "./icons/BrandIcons";

const MAP = [
  { key: "spotify", label: "Spotify", Icon: SpotifyIcon },
  { key: "apple_music", label: "Apple Music" },
  { key: "youtube_music", label: "YouTube Music", Icon: YouTubeIcon },
  { key: "amazon_music", label: "Amazon Music" },
  { key: "deezer", label: "Deezer" },
  { key: "tidal", label: "Tidal" },
];

export default function StreamingBar({ streaming = {} }) {
  const items = MAP.filter((m) => streaming[m.key]);
  if (items.length === 0) return null;
  return (
    <section data-testid="streaming-bar" className="px-6 pb-4 sm:px-10 lg:px-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <div className="flex flex-wrap items-center gap-2.5 rounded-3xl border border-white/10 bg-surface/40 p-4">
            <span className="mr-1 text-xs font-bold uppercase tracking-widest text-white/40">Listen on</span>
            {items.map((m) => (
              <a
                key={m.key}
                href={streaming[m.key]}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`streaming-${m.key}`}
                onClick={() => trackOutbound(m.key, { metadata: { placement: "streaming_bar" } })}
                className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.03] px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-white/80 transition-transform active:scale-95 hover:border-gold/40 hover:text-gold"
              >
                {m.Icon ? <m.Icon size={16} /> : null}
                {m.label}
                <ExternalLink size={12} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
